import React from 'react'

const Tube = ({ num, percentage }) => {
    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div><span>{num}</span></div>
                    <div style={{ flexGrow:1, maxWidth:200, height: 10, borderRadius: 10, backgroundColor: 'gray', }}>
                    <div style={{ width:percentage? `${percentage}%`:'10%',height: 10, borderRadius: 10, backgroundColor: '#03a56a', }}>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Tube